var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rule"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.54 10.9997L13 7.45969L14.41 6.04969L16.53 8.16969L20.77 3.92969L22.18 5.33969L16.54 10.9997ZM11 6.99969H2V8.99969H11V6.99969ZM21 13.4097L19.59 11.9997L17 14.5897L14.41 11.9997L13 13.4097L15.59 15.9997L13 18.5897L14.41 19.9997L17 17.4097L19.59 19.9997L21 18.5897L18.41 15.9997L21 13.4097ZM11 14.9997H2V16.9997H11V14.9997Z",
    fill: "#9DA5BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanReview);
export default __webpack_public_path__ + "static/media/scan_review.609a524987fcc06864136eca87cf8144.svg";
export { ForwardRef as ReactComponent };